import PropTypes from "prop-types";
import React, { useState } from "react";

import { Alert, Form, Input, FormFeedback, Label, Spinner } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "../../store/actions";

// import images
import logo from "assets/images/logo-dark.png";

// Giriş ekranı, panelin geri kalanından bağımsız bir sayfa olduğu için
// stiller global SCSS'e dokunmadan burada, "bh-" öneki ile tutuluyor.
const loginStyles = `
.bh-login {
  min-height: 100vh;
  display: flex;
  background: #ffffff;
}
.bh-login__brand {
  position: relative;
  flex: 0 0 52%;
  max-width: 52%;
  overflow: hidden;
  background: linear-gradient(135deg, #08351c 0%, #0a4022 45%, #12572f 100%);
  color: #fff;
  padding: 56px 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/* Baharat tonlarında yumuşak ışık lekeleri */
.bh-login__brand::before,
.bh-login__brand::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
}
.bh-login__brand::before {
  width: 520px; height: 520px;
  top: -190px; right: -170px;
  background: radial-gradient(circle, rgba(217,154,43,.30) 0%, rgba(217,154,43,0) 70%);
}
.bh-login__brand::after {
  width: 460px; height: 460px;
  bottom: -180px; left: -140px;
  background: radial-gradient(circle, rgba(225,18,28,.20) 0%, rgba(225,18,28,0) 70%);
}
.bh-login__brand > * { position: relative; z-index: 1; }

.bh-login__logo-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 14px;
  padding: 14px 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,.18);
}
.bh-login__logo-chip img { height: 38px; width: auto; display: block; }

.bh-login__title {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 0 0 14px;
  color: #fff;
}
.bh-login__subtitle {
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255,255,255,.78);
  max-width: 430px;
  margin: 0;
}
.bh-login__features {
  list-style: none;
  padding: 0;
  margin: 32px 0 0;
  display: grid;
  gap: 14px;
}
.bh-login__features li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: .95rem;
  color: rgba(255,255,255,.9);
}
.bh-login__features i {
  width: 34px; height: 34px;
  flex: 0 0 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(217,154,43,.18);
  color: #e5b45a;
  font-size: 1.05rem;
}
.bh-login__foot {
  font-size: .8rem;
  color: rgba(255,255,255,.55);
  margin: 0;
}

.bh-login__panel {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
}
.bh-login__form {
  width: 100%;
  max-width: 400px;
}
.bh-login__form-logo { display: none; }
.bh-login__heading {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0a4022;
  margin: 0 0 6px;
}
.bh-login__hint {
  color: #6c7a72;
  font-size: .92rem;
  margin: 0 0 30px;
}
.bh-login .form-label {
  font-weight: 600;
  font-size: .85rem;
  color: #3d4a44;
  margin-bottom: 6px;
}
.bh-login .form-control {
  height: 48px;
  border-radius: 10px;
  border: 1px solid #dfe4e1;
  padding-left: 42px;
  font-size: .95rem;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.bh-login .form-control:focus {
  border-color: #0a4022;
  box-shadow: 0 0 0 3px rgba(10,64,34,.12);
}
.bh-login__field { position: relative; }
.bh-login__field > .bh-login__icon {
  position: absolute;
  left: 14px;
  top: 13px;
  font-size: 1.15rem;
  color: #9aa7a0;
  pointer-events: none;
  z-index: 4;
}
.bh-login__reveal {
  position: absolute;
  right: 6px;
  top: 7px;
  z-index: 4;
  border: 0;
  background: transparent;
  color: #9aa7a0;
  width: 34px; height: 34px;
  border-radius: 8px;
  font-size: 1.15rem;
  line-height: 1;
  cursor: pointer;
}
.bh-login__reveal:hover { color: #0a4022; background: #f1f4f2; }
/* Doğrulama mesajı input'un altında kalsın */
.bh-login__field .invalid-feedback { padding-left: 2px; }
/* Bootstrap'in sağdaki uyarı ikonu, şifre göster/gizle butonunun altında kalıyor;
   hata mesajı zaten alanın altında göründüğü için ikonu kapatıyoruz. */
.bh-login .form-control.is-invalid { background-image: none; padding-right: .75rem; }

.bh-login__submit {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 10px;
  background: #0a4022;
  color: #fff;
  font-weight: 600;
  font-size: .98rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background .15s ease, transform .05s ease;
}
.bh-login__submit:hover:not(:disabled) { background: #0d5630; }
.bh-login__submit:active:not(:disabled) { transform: translateY(1px); }
.bh-login__submit:disabled { opacity: .7; cursor: not-allowed; }

.bh-login__remember {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 18px 0 24px;
}
.bh-login__remember input { width: 16px; height: 16px; cursor: pointer; margin: 0; }
.bh-login__remember label { font-size: .9rem; color: #4a564f; cursor: pointer; margin: 0; }

.bh-login__copy {
  text-align: center;
  font-size: .8rem;
  color: #9aa7a0;
  margin: 28px 0 0;
}

@media (max-width: 991.98px) {
  .bh-login { flex-direction: column; min-height: 100vh; }
  .bh-login__brand { display: none; }
  .bh-login__panel { flex: 1 1 auto; padding: 40px 20px; }
  .bh-login__form-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 26px;
  }
  .bh-login__form-logo img { height: 46px; width: auto; }
  .bh-login__heading, .bh-login__hint { text-align: center; }
}
`;

const Login = props => {

  //meta title
  document.title = "Giriş | Buhara - Admin Paneli";

  const [getIsActive, setIsActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [getMail, setMail] = useState("");
  const [getPassword, setPassword] = useState("");

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: getMail != null ? getMail : '',
      password: getPassword != null ? getPassword : '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Lütfen Mail Adresini Giriniz"),
      password: Yup.string().required("Lütfen Şifrenizi Giriniz"),
    }),
    onSubmit: (values) => {

      if (getIsActive === true) {
        localStorage.setItem("rememberMail", values.email);
        localStorage.setItem("rememberPassword", values.password);
        localStorage.setItem("rememberCheck", "true");
      } else {
        // "Beni Hatırla" kapalıysa daha önce kaydedilmiş bilgileri temizle.
        localStorage.removeItem("rememberMail");
        localStorage.removeItem("rememberPassword");
        localStorage.removeItem("rememberCheck");
      }

      dispatch(loginUser(values, props.router.navigate));
    }
  });

  const { error, loading } = useSelector(state => ({
    error: state.Login.error,
    loading: state.Login.loading,
  }));

  React.useEffect(() => {
    const rememberMe = localStorage.getItem("rememberCheck");

    if (rememberMe === "true") {
      setIsActive(true);
      setMail(localStorage.getItem("rememberMail") || "");
      setPassword(localStorage.getItem("rememberPassword") || "");
    }
  }, []);

  return (
    <React.Fragment>
      <style>{loginStyles}</style>

      <div className="bh-login">

        {/* Sol marka paneli (mobilde gizlenir) */}
        <aside className="bh-login__brand">
          <div className="bh-login__logo-chip">
            <img src={logo} alt="Buhara Baharat" />
          </div>

          <div>
            <h1 className="bh-login__title">
              Buhara Baharat<br />Yönetim Paneli
            </h1>
            <p className="bh-login__subtitle">
              Tarifleri, ürünleri ve site içeriğini tek yerden yönetin.
            </p>

            <ul className="bh-login__features">
              <li><i className="mdi mdi-silverware-fork-knife" /> Tarif, malzeme ve hazırlanış adımları</li>
              <li><i className="mdi mdi-package-variant-closed" /> Ürün kataloğu ve kategoriler</li>
              <li><i className="mdi mdi-translate" /> Beş dilde içerik yönetimi</li>
            </ul>
          </div>

          <p className="bh-login__foot">
            © {new Date().getFullYear()} Buhara Baharat
          </p>
        </aside>

        {/* Sağ form paneli */}
        <main className="bh-login__panel">
          <div className="bh-login__form">

            {/* Mobilde marka paneli gizlendiği için logo forma taşınıyor */}
            <div className="bh-login__form-logo">
              <img src={logo} alt="Buhara Baharat" />
            </div>

            <h2 className="bh-login__heading">Giriş Yap</h2>
            <p className="bh-login__hint">Devam etmek için hesap bilgilerinizi girin.</p>

            <Form
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              {error ? <Alert color="danger">{error}</Alert> : null}

              <div className="mb-3">
                <Label className="form-label" for="bh-email">Mail Adresi</Label>
                <div className="bh-login__field">
                  <i className="mdi mdi-email-outline bh-login__icon" />
                  <Input
                    id="bh-email"
                    name="email"
                    className="form-control"
                    placeholder="ornek@buhara.com"
                    type="email"
                    autoComplete="username"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email || ""}
                    invalid={
                      validation.touched.email && validation.errors.email ? true : false
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="mb-3">
                <Label className="form-label" for="bh-password">Şifre</Label>
                <div className="bh-login__field">
                  <i className="mdi mdi-lock-outline bh-login__icon" />
                  <Input
                    id="bh-password"
                    name="password"
                    value={validation.values.password || ""}
                    type={showPassword ? "text" : "password"}
                    placeholder="Şifrenizi girin"
                    autoComplete="current-password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.password && validation.errors.password ? true : false
                    }
                  />
                  <button
                    type="button"
                    className="bh-login__reveal"
                    onClick={() => setShowPassword(v => !v)}
                    aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                    title={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                  >
                    <i className={showPassword ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"} />
                  </button>
                  {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                  ) : null}
                </div>
              </div>

              <div className="bh-login__remember">
                <input
                  type="checkbox"
                  id="bh-remember"
                  className="form-check-input"
                  checked={getIsActive}
                  onChange={() => setIsActive(v => !v)}
                />
                <label className="form-check-label" htmlFor="bh-remember">
                  Beni Hatırla
                </label>
              </div>

              <button
                className="bh-login__submit"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" /> Giriş Yapılıyor...
                  </>
                ) : (
                  "Giriş Yap"
                )}
              </button>
            </Form>

            <p className="bh-login__copy">
              Buhara Baharat Yönetim Paneli
            </p>
          </div>
        </main>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
  router: PropTypes.object,
};
